import { useEffect, useRef, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * Cross-app SSO handoff, landing side (`backend/app/services/sso_service.py`'s
 * module docstring has the full design). Reached either from another app's
 * "Open Dashboard" link (`?code=...` minted by that app's own
 * `POST /auth/sso/initiate`) or from `GET /auth/demo/handoff`'s redirect
 * (marketing-site's "Try the Live Demo" button). Exchanges the code for a
 * real session and drops straight into the app — no password prompt.
 */
export function SsoConsumePage() {
  const { status, loginWithSsoCode } = useAuth();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [error, setError] = useState<string | null>(null);
  const attempted = useRef(false);

  useEffect(() => {
    if (!code || attempted.current) return;
    attempted.current = true;
    loginWithSsoCode(code).catch(() => {
      setError("This sign-in link has expired or was already used. Please log in again.");
    });
  }, [code, loginWithSsoCode]);

  if (status === "authenticated") return <Navigate to="/" replace />;
  if (!code) return <Navigate to="/login" replace />;

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>ZEL-MART</h1>
        {error ? (
          <>
            <p className="banner banner--error" role="alert">
              {error}
            </p>
            <p>
              <a href="/login">Go to login</a>
            </p>
          </>
        ) : (
          <p>Signing you in…</p>
        )}
      </div>
    </div>
  );
}
